import AboutFounder from "./AboutFounder";
import AboutText from "./AboutText";

const AboutContent = () => {
  return (
    <div className="px-4 py-8 text-base sm:text-lg md:text-xl md:px-12 lg:px-[8.5rem] lg:py-[6.5rem] lg:space-y-[6rem] space-y-16">
      <AboutText>
        <h1 className="pt-3 text-2xl sm:text-3xl md:text-4xl font-black">
          Our Story
        </h1>
        <div className="space-y-3">
          <p>
            In many parts of the world, the pursuit of lasting health and
            well-being for individuals, families, and society as a whole remains
            a challenge. However, I firmly believe that it doesn't have to stay
            that way, at least not for individuals who choose a different path.
          </p>
          <p>
            After careful consideration of the current state of our world, I've
            come to the conclusion that the most effective way to foster health
            and happiness within individuals, families, and society is to start
            at the most fundamental level – the individual. To achieve this, we
            decided to harness the power of the internet, creating this website
            as a bridge between those seeking health solutions and the
            empowerment they deserve
          </p>
        </div>
      </AboutText>

      <AboutText>
        <h1 className="pt-3 text-2xl sm:text-3xl md:text-4xl font-black">
          Our Mission
        </h1>
        <div className="space-y-3">
          <p>
            Our mission here doesn't follow the traditional theoretical approach
            to achieving good health and well-being. Instead, we are dedicated
            to pursuing practical and viable methods to attain the shared goal
            of a healthy and hearty populace, a desire held by the majority, if
            not everyone.
          </p>
          <p>
            To begin, it's essential to recognize that many diseases lack a
            cure. Conventional medical facilities worldwide often fall short in
            meeting the healthcare needs of the majority. This realization has
            driven us to take action and contribute to bridging this gap.
          </p>
        </div>
      </AboutText>

      <AboutFounder />
    </div>
  );
};

export default AboutContent;
